import React from 'react';
import {Marker, Callout} from 'react-native-maps';
import {ActivityIndicator, Platform} from 'react-native';
import {showLocation} from 'react-native-map-link';

import {
  MarkerWrapper,
  NearestBadge,
  NearestBadgeText,
  MarkerView,
  CalloutContainer,
  CalloutInfosContainer,
  CalloutAvatar,
  CalloutInfos,
  CalloutText,
  CalloutSubtext,
  CalloutButton,
  CalloutButtonText,
  LinkButtonContainer,
} from './styles';
import {Badge} from '../../Interface/Badges/Badge';
import {LinkButton} from '../../Interface/Forms/Buttons/LinkButton';
import {RFValue} from 'react-native-responsive-fontsize';

import {StationDTO} from '../../../dtos/StationDTO';

interface StationMarkerProps {
  marker: StationDTO;
  selectedCategories: string;
  isLoadingOrder: boolean;
  position?: {
    latitude: number;
    longitude: number;
  };
  theme: any; // Ou o tipo do seu Theme
  handleStation: (tipo: string, data: StationDTO) => void;

  // Novas props
  isSelected: boolean;
  isNearest?: boolean;
  onSelect: () => void;
}

export function StationMarker({
  marker,
  selectedCategories,
  isLoadingOrder,
  position,
  theme,
  handleStation,
  isSelected,
  isNearest = false,
  onSelect,
}: StationMarkerProps) {
  return (
    <Marker
      key={marker.id}
      coordinate={{
        latitude: marker.lat,
        longitude: marker.lng,
      }}
      onPress={onSelect}
      title={marker.name}
      description={marker.neighbourhood}>
      {/* Ícone do Marker */}

      <MarkerWrapper>
        {isNearest && (
          <NearestBadge>
            <NearestBadgeText>Mais próximo</NearestBadgeText>
          </NearestBadge>
        )}
        <MarkerView
          source={{uri: marker.flag_image}}
          isNearest={isNearest}
          isSelected={isSelected}
        />
      </MarkerWrapper>

      {Platform.OS === 'ios' && (
        <Callout tooltip>
          <CalloutContainer>
            <CalloutInfosContainer>
              <CalloutAvatar source={{uri: marker.flag_image}} />
              <CalloutInfos>
                <CalloutText>
                  {marker.name.length > 32
                    ? marker.name.substring(0, 32) + '...'
                    : marker.name}
                </CalloutText>
                <CalloutSubtext>
                  {marker.neighbourhood.substring(0, 1) === ' '
                    ? marker.neighbourhood.substring(1)
                    : marker.neighbourhood}
                </CalloutSubtext>

                {marker.categoria === 'ouro' && (
                  <Badge
                    text="Super Barato"
                    containerStyle={{
                      backgroundColor: theme.colors.gold,
                      borderColor: theme.colors.gold_dark,
                    }}
                    textStyle={{color: theme.colors.gold_text}}
                  />
                )}
                {marker.categoria === 'prata' && (
                  <Badge
                    text="Barato"
                    containerStyle={{
                      backgroundColor: theme.colors.silver,
                      borderColor: theme.colors.silver_dark,
                    }}
                    textStyle={{color: theme.colors.silver_text}}
                  />
                )}
              </CalloutInfos>
            </CalloutInfosContainer>

            <CalloutButton
              disabled={isLoadingOrder}
              style={{opacity: isLoadingOrder ? 0.7 : 1}}
              onPress={() => handleStation(selectedCategories, marker)}>
              {isLoadingOrder ? (
                <ActivityIndicator color="white" />
              ) : (
                <CalloutButtonText>Comprar agora</CalloutButtonText>
              )}
            </CalloutButton>

            <LinkButtonContainer>
              <LinkButton
                color={theme.colors.blue}
                enabled
                fontSize={RFValue(10)}
                text="Abrir no mapa"
                action={() => {
                  showLocation({
                    latitude: marker.lat,
                    longitude: marker.lng,
                    title: marker.name,
                    sourceLatitude: position?.latitude,
                    sourceLongitude: position?.longitude,
                    appsWhiteList: ['waze', 'apple-maps', 'google-maps'],
                    dialogTitle: 'Abrir em qual App?',
                    dialogMessage: 'Escolha o aplicativo de navegação',
                    cancelText: 'Cancelar',
                    directionsMode: 'car',
                  });
                }}
              />
            </LinkButtonContainer>
          </CalloutContainer>
        </Callout>
      )}
    </Marker>
  );
}
